// English twin of de/help.js, which carries the rules the copy follows. See docs/view-help.md.
import timetracking from "@/plugins/i18n/en/help/timetracking"
import projects from "@/plugins/i18n/en/help/projects"
import projectcosts from "@/plugins/i18n/en/help/projectcosts"
import hourlywageinvoice from "@/plugins/i18n/en/help/hourlywageinvoice"
import customers from "@/plugins/i18n/en/help/customers"
import employees from "@/plugins/i18n/en/help/employees"
import materials from "@/plugins/i18n/en/help/materials"
import machines from "@/plugins/i18n/en/help/machines"
import packets from "@/plugins/i18n/en/help/packets"
import personnelplanning from "@/plugins/i18n/en/help/personnelplanning"
import settings from "@/plugins/i18n/en/help/settings"
import files from "@/plugins/i18n/en/help/files"
import daysubmissions from "@/plugins/i18n/en/help/daysubmissions"

// One file per tour under help/, so tours are written independently of each other.
export default {
  trigger: {
    label: "Explain",
    aria: "Start the explanation of this page",
  },
  action: {
    close: "Close the explanation",
  },
  key: {
    ctrl: "Ctrl",
    shift: "Shift",
  },
  hint: {
    next: "Next",
    continue_to: "Next: {view}",
  },
  player: {
    play: "Play",
    pause: "Pause",
    replay: "Play from the start",
    speed: "Speed {speed}",
    speed_menu: "Playback speed",
    segment: "Step {number} of {total}",
    section: "{view}, {count} step, expand | {view}, {count} steps, expand",
    steps: "{count} step | {count} steps",
    shortcuts: "Keyboard shortcuts",
  },
  shortcuts: {
    title: "Keyboard shortcuts",
    close: "Close keyboard shortcuts",
    play: "Play or pause",
    step: "One step back or forward",
    view: "One view back or forward",
    jump: "Straight to a view",
    edges: "First or last step",
    speed: "Slower or faster",
    list: "Show or hide this list",
    exit: "Close the explanation",
  },
  keys: {
    space: "Space",
    shift: "Shift",
    home: "Home",
    end: "End",
  },
  flash: {
    playing: "Playing",
    paused: "Paused",
  },
  // The screen at the end of the walkthrough: what was seen, the way back into any page, and out.
  end: {
    title: "“{tour}” explained",
    // "25 steps on 6 pages"
    lead: "{steps} on {pages}",
    pages: "{count} page | {count} pages",
    revisit: "Watch again",
    hint: "Start it again any time with “{trigger}” next to the heading.",
    replay: "From the start",
    close: "Close",
  },
  aria: {
    dialog: "Explanation of this page",
    frame: "The application, with sample data",
  },
  demo: {
    chip: "Sample data",
  },
  tour: {
    timetracking,
    projects,
    projectcosts,
    hourlywageinvoice,
    customers,
    employees,
    materials,
    machines,
    packets,
    personnelplanning,
    settings,
    files,
    daysubmissions,
  },
}
